export const endpointConstants ={
    PING_REQUEST:"ENDPOINT_PING_REQUEST",
    PING_SUCCESS:"ENDPOINT_PING_SUCCESS",
    PING_ERROR:"ENDPOINT_PING_ERROR"
}